import './DiscoveryHubShelf.scss'

import { InView } from 'react-intersection-observer'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import type { MakeViewItemListEventProps } from 'src/utils/restructure/analytics'
import {
  makeViewItemListEvent,
  makeViewListImpressionEvent,
  sendEvent,
} from 'src/utils/restructure/analytics'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import type { Product } from '../../../restructure/product/types/product'
import DiscoveryHubProductCard from './DiscoveryHubProductCard'

interface DiscoveryHubShelf {
  setCloseSearchHubModal: (value: boolean) => void
  products: Product[]
  title: string
  dynamicRecommendations?: Product[]
  testId?: string
}

export default function DiscoveryHubShelf({
  setCloseSearchHubModal,
  dynamicRecommendations,
  products,
  title,
  testId,
}: DiscoveryHubShelf) {
  const { pageData } = useGlobalContext()
  const standardObj = getStandardObject(pageData)

  if (!products || !products.length) {
    return null
  }

  const productsCount = products.length

  function handleProductViewed() {
    dispatchAmplitudeEvent({
      eventName: 'Product List Viewed',
      eventData: {
        ...standardObj,
        'product list type': pageData.currentPageType,
        'product list name': `Vitrine: ${title}`,
        'number of products': productsCount,
        productsCount,
      },
    })

    if (!dynamicRecommendations) {
      return
    }

    const items = dynamicRecommendations.map((product: Product) => ({
      product,
      productItem: product.items[0],
      listName: `vitrine - ${title}`,
      listId: 'NA',
    }))

    const viewListImpressionEvent = makeViewListImpressionEvent(items, {
      listName: `vitrine - ${title}`,
      dimension29: 'dy',
    })

    const viewItemListEvent = makeViewItemListEvent(
      items as unknown as MakeViewItemListEventProps
    )

    sendEvent(viewListImpressionEvent)
    sendEvent(viewItemListEvent)
  }

  return (
    <InView
      onChange={(inView) => {
        if (inView) {
          handleProductViewed()
        }
      }}
      triggerOnce
    >
      <div
        className="discovery-hub-shelf-container w-full overflow-x-auto"
        data-testid={testId}
      >
        <ul className="flex flex-nowrap min-w-max gap-2 pr-4">
          {products?.map((product, index) => {
            return (
              <li key={index} className="discovery-hub-shelf-item w-[107px]">
                <DiscoveryHubProductCard
                  product={product}
                  shelfTitle={title}
                  index={index}
                  setCloseSearchHubModal={setCloseSearchHubModal}
                />
              </li>
            )
          })}
        </ul>
      </div>
    </InView>
  )
}
